





































































































import { Component, Watch } from 'vue-property-decorator';
import { AppModule } from '@/store/Auth/AppModule';
import { CustomerModule } from '@/store/Customers/CustomerModule';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import FieldLabel from '@/components/Shared/FieldLabel.vue';
import ListUtils from '@/lib/listUtils';
import ajax from '@/lib/ajax';
import ProductState from '@/models/Products/ProductState';
import ProductType from "@/models/Products/ProductType";
import Product from '@/models/Products/Product';
import CreateCustomerAccountRequest from '@/models/Customers/Customers/CreateCustomerAccountRequest';
import PageNames from '@/router/PageNames';
import ProductIssueType from '@/models/Products/ProductIssues/ProductIssueType';
import PermissionUtils from '@/lib/permissionUtils';

@Component({ name: 'CustomerAccountCreate', components: { FieldLabel } })
export default class extends SaascadaVueDialog {

    selectedProductType: string = '';
    selectedProductSubType: string = '';
    selectedProductID: string = '';
    productIssueSelectionType: string = '';
    selectedProductIssueID: string = '';
    accountName: string = '';
    accountIBAN: string = '';

    productOptions: Product[] = [];
    productIssueOptions: [] = [];

    ProductIssueType = ProductIssueType;

    public request: CreateCustomerAccountRequest = new CreateCustomerAccountRequest();

    get loadingNewCustomerAccount() {
        return CustomerModule.loadingNewCustomerAccount;
    }

    get productTypeOptions() {
        return ListUtils.productTypeOptions();
    }

    get productSubTypeOptions() {
        if (this.selectedProductType === ProductType.Deposit) {
            return ListUtils.depositProductSubTypeOptions();
        }
        else {
            return ListUtils.lendingProductSubTypeOptions();
        }
    }

    get hasSwisscomBankingIntegration() {
        return PermissionUtils.hasSwisscomBankingIntegration();
    }

    @Watch('selectedProductSubType')
    async onSelectedProductSubTypeChanged() {
        if (this.selectedProductType && this.selectedProductSubType) {
            await ajax.get(`/portal-backend/fi-api/internal/products?type=${this.selectedProductType}&subType=${this.selectedProductSubType}`)
            .then(response => {
                const allProductOptions = response.data.results;
                // Filter out products that have are in a pending state as we cannot create accounts with these products
                this.productOptions = allProductOptions.filter((productOption: Product) => { return productOption.state !== ProductState.Pending; });
            })
            .catch(error => {
                AppModule.handleApiError(error);
            });
        }
    }

    @Watch('selectedProductID')
    async onSelectedProductChanged() {
        if (this.selectedProductID) {
            await ajax.get(`/portal-backend/fi-api/internal/product-issues?productId=${this.selectedProductID}`)
            .then(response => {
                this.productIssueOptions = response.data.results;
                // Set a default name of the account to save time making up a name every time
                const selectedProduct = this.productOptions.find((product) => { return product.id === this.selectedProductID; });
                this.accountName = `${CustomerModule.customer.name} ${selectedProduct.generalSettings.name}`;
                // Sanitise the default name by replacing underscores which are invalid with hyphens
                this.accountName = this.accountName.replace('_', '-');
            })
            .catch(error => {
                AppModule.handleApiError(error);
            });
        }
    }

    async save() {
        if (!(this.$refs.form as any).validate()) {
            return;
        }
        else {
            this.dialog = false;

            // Collect all the data needed for the account creation request
            // Note we only send productIssueId if a specific product issue was selected
            this.request.name = this.accountName;
            this.request.productId = this.selectedProductID;
            this.request.productIssueId = this.productIssueSelectionType === ProductIssueType.SelectAnIssue ? this.selectedProductIssueID : undefined;
            this.request.reviewDateUtc = new Date();
            this.request.customerId = CustomerModule.customer.id;
            this.request.iban = this.accountIBAN ? this.accountIBAN : undefined;

            await CustomerModule.createCustomerAccount(this.request);

            if (CustomerModule.newCustomerAccountID !== null) {
                const accountPageName = this.selectedProductType === ProductType.Deposit ? PageNames.DepositAccount : PageNames.LendingAccount;
                this.$router.push({ name: accountPageName, params: { id: CustomerModule.newCustomerAccountID }, query: { tab: "0" } });
            }
        }
    }

    cancel() {
        this.dialog = false;
    }

}
